import request from '@/utils/http'
// import global_var from '@/api/global_var.js'    //引用文件

const BASE_URL = "https://204910013.xyz/";
// const BASE_URL = "http://localhost:8080/";

// const BASE_URL = global_var.baseURL

// 根据用户id获取好友列表
export const selectFriendList = (userId) => {
    return request.requestGet(BASE_URL+"portal/chat/getFriendList?userId="+userId)
};

// 搜索好友
export const searchUser = (userName) => {
    return request.requestGet(BASE_URL+"portal/chat/user/search?userName="+userName)
};

// 添加好友
export const addFriend = (userId,friendId) => {
    const data = {
        userId,
        friendId,
    }
    return request.requestPost(BASE_URL+"portal/chat/addFriend",data)
};
